export const getHiringStatusClass = status => {
    switch ((status || "").toLowerCase()){
        case "applied":
            return "bg-blue-100 text-blue-800"
        case "holded":
            return "bg-amber-100 text-amber-800"
        case "rejected":
            return "bg-rose-100 text-rose-800"
        case "shortlisted":
            return "bg-emerald-100 text-emerald-800"
        case "hired":
            return "bg-purple-100 text-purple-800"
        default:
            return "bg-gray-100 text-gray-800"
    }
}

export const handleSearchTextChange = (e, setTempSearchTerm, setSearchTerm, fetchJobs) => {
    const { value } = e.target
    setTempSearchTerm(value)
    if (value === "") {
        setSearchTerm(value)
        fetchJobs()
        return
    }
}

export const handleSearchKeyDown = (e, setSearchTerm, fetchJobs) => {
    if (e.key === "Enter" && e.target.value){
        setSearchTerm(e.target.value)
        fetchJobs()
    }
}

export const handleSearch = (tempSearchTerm, setSearchTerm, fetchJobs) => {
    if (tempSearchTerm) {
        setSearchTerm(tempSearchTerm)
        fetchJobs()
    }
}

export const handlePerPageChange = (e, setPagination) => {
    setPagination(prev => ({ ...prev, perPage: e.target.value }))
}

export const goToPage = (page, setPagination) => {
    if (!page || page < 1) return
    setPagination(prev => ({ ...prev, currentPage: page }))
}